import { reactive } from 'vue'

export const store = reactive({
  name: null,
  email: null,
  memberNumber: null,
  allowsPhotos: null,
  cameFromEventPage: null,
  updateName(name) {
    this.name = name;
  },
  updateEmail(email) {
    this.email = email;
  },
  updateMemberNumber(memberNumber) {
    this.memberNumber = memberNumber;
  },
  updateAllowsPhotos(allowsPhotos) {
    this.allowsPhotos = allowsPhotos;
  },
  updateCameFromEventPage(cameFromEventPage) {
    this.cameFromEventPage = cameFromEventPage;
  }
})